import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

interface RequestStats {
  doneAt: number;
}

@Module
export default class ApiRequestsStatsModule extends VuexModule {
  requestStats: { [index: string]: RequestStats } = {};

  get requestDoneAt() {
    return (action: Actions | string): number => {
      return this.requestStats[action]?.doneAt || 0;
    };
  }

  @Mutation
  [Mutations.COMMON_REQUEST_DONE](action: Actions | string) {
    this.requestStats[action] = {
      doneAt: Date.now(),
    };
  }

  @Mutation
  [Mutations.COMMON_REQUEST_STATS_RESET]() {
    this.requestStats = {};
  }
}
